module.exports = __webpack_public_path__ + "assets/img/5.34565234.gif";